import { Component } from '@angular/core';
import { BackendApiService } from '../services/backend-api.service';
import { BaseUrlConstantsService } from '../services/base-url-constants.service';
import { MatIcon } from '@angular/material/icon';
import { DeviceMacModalComponent } from '../device-mac-modal/device-mac-modal.component';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
@Component({
  selector: 'app-device-usage',
  standalone: true,
  imports: [MatIconModule, DeviceMacModalComponent, FormsModule],
  templateUrl: './device-usage.component.html',
  styleUrl: './device-usage.component.scss'
})
export class DeviceUsageComponent {
  public role = localStorage.getItem("role");
  private userId = localStorage.getItem("user_id");
  public totalClients: number = 0;
  public totalDevices: number = 0;
  public overallOnlinePercentage: number = 0;
  public overallOfflinePercentage: number = 0;
  public clientCardData: any = [];
  public isModalOpen: boolean = false;
  public deviceMacArray: any[] = [];
  public filterType: string = "currentMonth";
  public startDate: string = "";
  public endDate: string = "";
  public thisMonth: boolean = true;
  public prevMonth: boolean = false;
  public isLoadingCardData: boolean = true;
  public isLoadingOnlineOffline: boolean = true;
  public isLoadingClient: boolean = true;
  public isLoadingDevices: boolean = true;
  constructor(private service: BackendApiService) {

  }

  ngOnInit(): void {
    this.initializeDateFilters();
    this.getTotalClients();
    this.getTotalDevices();
    this.getOverallOnlineOfflinePercentage();
    this.getClientCardData();
  }

  async getTotalClients() {
    try {
      const result: any = await this.service.getDataV2(BaseUrlConstantsService.GET_TOTAL_USER);
      console.log(result);
      if (result.success === true) {
        this.totalClients = result.data.count;
        this.isLoadingClient = false;
      }
    }
    catch (error) {
      console.log(error);
    }
    finally {
      this.isLoadingClient = false;
    }
  }

  async getTotalDevices() {
    try {
      const result: any = await this.service.getDataV2(BaseUrlConstantsService.GET_TOTAL_DEVICES);
      console.log(result);
      if (result.success === true) {
        this.totalDevices = result.data.count;
        this.isLoadingDevices = false;
      }
    }
    catch (error) {
      console.log(error)
    }
    finally {
      this.isLoadingDevices = false;
    }
  }

  async getOverallOnlineOfflinePercentage() {
    try {
      const result: any = await this.service.getDataV2(BaseUrlConstantsService.GET_OVERALL_ONLINE_OFFLINE_PERCENTAGE + `?role=${this.role}&userId=${this.userId}&filterType=${this.filterType}&startDate=${this.startDate}&endDate=${this.endDate}`);
      console.log(result);
      if (result.success === true) {
        this.overallOnlinePercentage = result.data.overall_online_percentage;
        this.overallOfflinePercentage = result.data.overall_offline_percentage;
        this.isLoadingOnlineOffline = false;
      }
    }
    catch (error) {
      console.log(error)
    }
    finally {
      this.isLoadingOnlineOffline = false;
    }
  }

  async getClientCardData() {
    try {
      let result: any;
      if(this.role === 'CLIENT')
        result = await this.service.getDataV2(BaseUrlConstantsService.GET_CLIENT_CARD_DATA + `?role=${this.role}&userId=${this.userId}&filterType=${this.filterType}&startDate=${this.startDate}&endDate=${this.endDate}`);
      else if(this.role === 'ADMIN')
        result = await this.service.getDataV2(BaseUrlConstantsService.GET_CLIENT_CARD_DATA + `?role=${this.role}&userId=${this.userId}&filterType=${this.filterType}&startDate=${this.startDate}&endDate=${this.endDate}`)
      console.log(result);

      if (result.success === true) {
        const cardDataArray = Object.keys(result.data).map((userId) => {
          const userData = result.data[userId];
          const totalDevices = userData.totalMacs;
          const excellentPercent = totalDevices > 0 ? (userData.devicesAbove95 / totalDevices) * 100 : 0;
          const goodPercent = totalDevices > 0 ? (userData.devicesBetween90And95 / totalDevices) * 100 : 0;
          const attentionPercent = totalDevices > 0 ? (userData.devicesBelow90 / totalDevices) * 100 : 0;
          return {
            isDetailsVisible: false,
            userId: userData.user_id,
            totalMacs: userData.totalMacs,
            devicesAbove95: userData.devicesAbove95,
            devicesBetween90And95: userData.devicesBetween90And95,
            devicesBelow90: userData.devicesBelow90,
            excellentPercent: Math.round(excellentPercent),
            goodPercent: Math.round(goodPercent),
            attentionPercent: Math.round(attentionPercent),
            company_name: userData.companyname,
            email: userData.email,
            phone_no: userData.phone_no,
            address: userData.address,
            industry_type: userData.industry_type
          };
        });


        console.log("Processed card data:", cardDataArray);
        this.clientCardData = cardDataArray;
        this.isLoadingCardData = false;
      }
    } catch (error) {
      console.log(error);
    }
    finally {
      this.isLoadingCardData = false;
    }
  }

  toggleDetails(clickedItem: any) {
    console.log(clickedItem);
    this.clientCardData.forEach(item => {
      item.isDetailsVisible = (item === clickedItem) ? !item.isDetailsVisible : false;
    });
  }

  openModal(item: any) {
    console.log(item)
    this.isModalOpen = !this.isModalOpen;
    this.deviceMacArray = item;
    console.log(this.deviceMacArray)
  }

  closeModal() {
    console.log("close modal")
    this.isModalOpen = false;

  }

  onDateChange() {
    this.thisMonth = false;
    this.prevMonth = false;
    this.filterType = 'range';
    this.applyFilters();

  }

  onThisMonthChange() {
    if (this.thisMonth) {
      this.prevMonth = false;
      const today = new Date();
      const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      const endOfToday = today;

      this.startDate = this.formatDate(startOfMonth);
      this.endDate = this.formatDate(endOfToday);
      this.filterType = "currentMonth";

      this.applyFilters();
    }
  }

  onPrevMonthChange() {
    if (this.prevMonth) {
      this.thisMonth = false;
      const today = new Date();
      const startOfPrevMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      const endOfPrevMonth = new Date(today.getFullYear(), today.getMonth(), 0); // day 0 of current month = last of previous

      this.startDate = this.formatDate(startOfPrevMonth);
      this.endDate = this.formatDate(endOfPrevMonth);
      this.filterType = "previousMonth";

      this.applyFilters();
    }
  }

  initializeDateFilters() {
    const today = new Date();
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const endOfToday = today;

    this.startDate = this.formatDate(startOfMonth);
    this.endDate = this.formatDate(endOfToday);
    this.thisMonth = true;
    this.prevMonth = false;
    this.filterType = "currentMonth";

    this.applyFilters();
  }
  private formatDate(date: Date): string {
    return date.toISOString().split('T')[0];
  }

  private applyFilters() {
    this.getClientCardData();
    this.getOverallOnlineOfflinePercentage();
  }
}
